<div class="container">
  <div class="row">
    <div class="shadow-sm mb-0">
      <div class="">
        <div class="row justify-content-center">
          <div class="col-md-8 my-4">
            <p class="fs-6 text-center">
              Select the publish icon next to a story to publish that story.
              Attachments, Write and Details sections must be complete to
              publish a story. When a story is ready to be published, the
              publish icon turns from gray to green. Once you have published
              five stories, you will be able to view your TSOLife account.
            </p>
            <p>
              Attachments, Write and Details sections must be complete in order
              to publish a story.
            </p>
            <h2 class="title text-center my-4">My Brainstorms</h2>
            <div class="card">
              <div class="card-body">
                <table class="table table-centered table-hover">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Attachments</th>
                      <th>Write</th>
                      <th>Details</th>
                      <th>Audio</th>
                      <th>Publish</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let item of brainstorms; let i = index">
                    <tr>
                      <td class="align-middle">{{ item.title }}</td>
                      <td class="story-action-icon">
                        <button class="btn btn-primary">
                          <i class="fas fa-plus"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button class="btn btn-primary">
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button type="submit" class="btn btn-primary btn-edit">
                          <i class="fas fa-list-alt"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button type="submit" class="btn btn-primary btn-edit">
                          <i class="fas fa-microphone-alt"></i>
                        </button>
                      </td>
                      <td class="story-action-icon">
                        <button type="submit" class="btn btn-primary btn-edit">
                          <i class="fas fa-book"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
